import CreditCardLogo from './CreditCardLogo';

export default CreditCardLogo;
